import { UsersIcon, ClipboardListIcon, UploadIcon, CreditCardIcon, UserIcon } from '../ui/icons';

// Mirrors the old admin Aside menu (newadmin/Aside.js) but targets /admin/*.
const NAV_SECTIONS = [
    {
        title: 'Applications',
        items: [
            {
                label: 'Applications',
                path: '/admin/applications',
                // "/admin" (dashboard) also lands on the applications page
                match: ['/admin', '/admin/applications'],
                icon: UsersIcon,
            },
            { label: 'Tracking', path: '/admin/tracking', icon: ClipboardListIcon },
        ],
    },
    {
        title: 'Settings',
        items: [
            { label: 'Document Collection', path: '/admin/settings/uploads', icon: UploadIcon },
            { label: 'Billing', path: '/admin/settings/billing', icon: CreditCardIcon },
            { label: 'Agents', path: '/admin/settings/agents', icon: UserIcon },
        ],
    },
];

export default NAV_SECTIONS;
